import React, { useContext, useEffect, useState } from "react";
import ArticleListItem from "../components/article-list-item";
import Layout from "../components/layout";
import PageSectionContainer from "../components/common/page-section-container";
import PageSectionHeading from "../components/common/page-section-heading";
import AuthContext from "../services/firebase/auth-context/provider";
import { bookmarkedArticleQuery, datoCmsId, fetchFromDatoCms, gatsbyDatoCmsId } from "../services/dato-cms";
import Error from "../components/common/error";
import LoadingSpinner from "../components/common/loading-spinner";
import { StatusType } from "../services/firebase/auth-context/reducer";
import { setBookmarked } from "../services/firebase/bookmarks";
import SEO from "../components/seo";
import Icon, { IconName } from "../components/icon";
const Bookmarks = () => {
    const { 0: bookmarkedArticles, 1: setBookmarkedArticles } = useState(null);
    const authContext = useContext(AuthContext);
    const { userData, authenticated } = authContext[0];
    useEffect(() => {
        if (authenticated && userData.status === StatusType.SUCCESS && userData.data && userData.data.bookmarks) {
            const bookmarks = userData.data.bookmarks;
            fetchBookmarkedArticles(bookmarks);
        }
    }, [authenticated, userData]);
    const fetchBookmarkedArticles = bookmarks => {
        const ids = bookmarks.map(it => datoCmsId(it));
        fetchFromDatoCms(bookmarkedArticleQuery(ids)).then(result => result.json()).then(data => setBookmarkedArticles(data.data.allArticles)).catch(error => {
            console.error(error);
        });
    };
    const removeBookmark = articleId => {
        setBookmarkedArticles(bookmarkedArticles.filter(it => it.id !== articleId));
        const id = gatsbyDatoCmsId(articleId, "Article");
        setBookmarked(id, false, authContext);
    };
    const renderBookmarkedArticles = () => {
        if (bookmarkedArticles && bookmarkedArticles.length > 0) {
            return bookmarkedArticles.map((article, index) => {
                var _article$image;
                const remove = () => removeBookmark(article.id);
                return /*#__PURE__*/ React.createElement(ArticleListItem, {
                    key: article.id,
                    authors: article.authors,
                    authorLinks: false,
                    excerpt: article.excerpt,
                    to: `/${article.slug}/`,
                    title: article.title,
                    image: (_article$image = article.image) === null || _article$image === void 0 ? void 0 : _article$image.responsiveImage,
                    smallTitle: article.smallTitle,
                    containerStyle: "pb-6",
                    index: index
                }, /*#__PURE__*/ React.createElement("div", {
                    className: "w-full flex justify-end"
                }, /*#__PURE__*/ React.createElement("button", {
                    onClick: remove,
                    className: "flex hover:underline"
                }, /*#__PURE__*/ React.createElement("div", {
                    className: "h-8 inline-block mr-2 flex flex-col justify-center"
                }, /*#__PURE__*/ React.createElement(Icon, {
                    iconName: IconName.DELETE,
                    className: "w-3",
                    color: "black"
                })), /*#__PURE__*/ React.createElement("div", {
                    className: "h-8 flex flex-col justify-center"
                }, /*#__PURE__*/ React.createElement("small", null, "Lesezeichen entfernen")))));
            });
        }
        else {
            return /*#__PURE__*/ React.createElement("div", null, "Keine Lesezeichen gesetzt.");
        }
    };
    const renderContent = () => {
        // TODO Probably the login page should be shown
        if (!authenticated) {
            return /*#__PURE__*/ React.createElement("div", {
                className: "mb-8"
            }, "Diese Funktion ist nur f\xFCr angemeldete Nutzer verf\xFCgbar");
        }
        else if (userData.status === StatusType.ERROR) {
            return /*#__PURE__*/ React.createElement(Error, {
                errorMessage: userData.error.message
            });
        }
        else if (userData.status === StatusType.LOADING || !bookmarkedArticles) {
            return /*#__PURE__*/ React.createElement(LoadingSpinner, null);
        }
        else {
            return renderBookmarkedArticles();
        }
    };
    return /*#__PURE__*/ React.createElement(Layout, null, /*#__PURE__*/ React.createElement(SEO, {
        title: "Lesezeichen"
    }), /*#__PURE__*/ React.createElement(PageSectionContainer, null, /*#__PURE__*/ React.createElement(PageSectionHeading, {
        className: "mb-4",
        title: "LESEZEICHEN"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-row flex-wrap"
    }, renderContent())));
};
export default Bookmarks;
